import React from "react";
import contentfulStandardApp, { fetchProps } from "@insightfulscience/contentful/Apps/Standard";
import VisualCopyBlock from "@insightfulscience/contentful/Apps/components/VisualCopyBlock";
import SiteLayout from "../../SiteLayout";
import BlockLinks from "../../contentful/Apps/components/BlockLinks";
import Page from "../../contentful/Apps/Standard/Page";
import resources from "../../../locales";
import { REVALIDATE_TIME, contentfulProps } from "../../config";
import LumaScientificIntelligencePlatformForm from "../../LumaScientificIntelligencePlatformForm";
import HeroBlock from "../../contentful/Apps/Standard/components/HeroBlock";

const VisualCopyBlockComponent = ({ ...props }) => (
	<VisualCopyBlock isImageFrame={false} ctaStyleType="primary" {...props} />
);

const lumaScientificIntelligencePlatformLayout = ({ children }) => {
	return (
		<SiteLayout>
			{children}
			<LumaScientificIntelligencePlatformForm />
		</SiteLayout>
	);
};

const ContentfulLumaScientificIntelligencePlatformLayoutApp = contentfulStandardApp({
	Layout: lumaScientificIntelligencePlatformLayout,
	Page,
	contentfulProps,
	pageProps: {
		resources,
		brandCode: "gn",
		siteDomain: "https://www.geneious.com",
		components: {
			linksBlock: BlockLinks,
			heroBlock: HeroBlock,
			visualCopyBlock: VisualCopyBlockComponent,
		},
	},
	mode: "isr",
});

export const getStaticProps = async () => {
	const props = await fetchProps(contentfulProps, "luma-scientific-intelligence-platform");

	return {
		props,
		revalidate: REVALIDATE_TIME,
	};
};

export default ContentfulLumaScientificIntelligencePlatformLayoutApp;
